  import { useRef, useState } from "react";
  import { ip, postAPI } from "../../api/api";
  import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../layout";
  import { StandardButton } from "../../atoms/buttons";
  import { Spinner } from "../../atoms/spinner";
  import { icon } from "../../functions/icons";
  import { set } from "date-fns";
  import JSConfetti from "js-confetti";
  import { padding } from "polished";
  import { TextAreaForm } from "../../atoms/input";
  import { TextAtom } from "../../atoms/TextAtom";
  import { IconAtom } from "../../atoms/iconAtom";
  var confettiEnabled = false;
  export default function AssessmentFinished({elearningInformation, id, leadEmail}) {
    const [completionEmail, setCompletionEmail] = useState("");
    const [emailSubmitting, setEmailSubmitting] = useState(false);
    const [emailSubmitted, setEmailSubmitted] = useState(false);  
    const [emailError, setEmailError] = useState("");
    const jsConfettiRef = useRef(null);
    const hasEmail = leadEmail && leadEmail.length > 0;
    const triggerConfetti = () => {
      const jsConfetti = jsConfettiRef.current || new JSConfetti();
      jsConfettiRef.current = jsConfetti;
      if (!confettiEnabled) {
        confettiEnabled = true;
        const interval = setInterval(() => jsConfetti.addConfetti(), 150);
        setTimeout(() => { clearInterval(interval); confettiEnabled = false; }, 1000);
      }
    };
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const handleEmailSubmit = async () => {
        if (emailSubmitted) return;
        if (!isValidEmail(completionEmail)) return setEmailError("Voer een geldig e-mailadres in.");
        setEmailSubmitting(true);
        try {
          const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
          const authToken = parsed?.token;
          const response = await fetch(`${ip}/api/embed/${id}/results`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Auth-Token": authToken },
            body: JSON.stringify({ email: completionEmail })
          });
          if (response.ok) setEmailSubmitted(true);
          else setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw.");
        } catch { setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw."); }
        finally { setEmailSubmitting(false); }
    };

    return (
      <div style={{ background: "var(--grey-50)", height: "100vh" }}>
        <div
          style={{ backgroundImage: `url('${elearningInformation.image_url}')` }}
          className="topbar-embed-bg"
        >
          <div className="topbar-embed">{elearningInformation.title}</div>
        </div>
        {hasEmail ? (<HasEmail leadEmail={leadEmail} id={id} />) : 
          (<NoEmail 
            completionEmail={completionEmail}
            setCompletionEmail={setCompletionEmail}
            emailError={emailError}
            handleEmailSubmit={handleEmailSubmit}
            emailSubmitting={emailSubmitting}
            emailSubmitted={emailSubmitted}
            triggerConfetti={triggerConfetti}
          />)
        }
      </div>
    );
  };

  const HasEmail = ({ leadEmail, id }) => {
    const [idReview, setIdReview] = useState(null);
    const submitReview = async ({ rating, feedback, sendEmail }) => {
      const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
      const session_token = parsed?.token;
      console.log("Review submitted:", { rating, feedback , session_token, id_course: id});
      const query = "api/embed/review";
      const body = {email: leadEmail, rating, feedback, session_token, id_course: id, sendEmail, id_review: idReview};
      const res = await postAPI(query, body);
      if(res.status === "ok"){
        console.log("Review successfully sent to the server.");
        console.log("Review ID:", res);
        setIdReview(res.data.id_review || null);
      }
    };

    return (
      <VerticalPageLayout className="center">
        <VerticalLayout className="center card-background-color" style={{ height: "auto", padding: "1rem",width: "clamp(10rem, 80%, 25rem)", border: "1px solid var(--grey-200)", borderRadius: "0.5rem", boxShadow: "var(--shadow-200)", gap: "1rem" }} >
          <IconAtom icon2={"checkbox-check"} iconSize={90} color="success-500" />
          <TextAtom className={"small-text-light"} title="Je hebt de e-learning afgerond 🎉" />
          <TextAtom className={"normal-text-dark semi-bold"} title="Wat vond je van deze e-learning?" />
          <ReviewBlock saveRating={submitReview} idReview={idReview} />
        </VerticalLayout>
      </VerticalPageLayout>
    );
  };

  const ReviewBlock = ({ saveRating, idReview }) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [feedback, setFeedback] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const handleSubmit = () => {
      saveRating({ rating, feedback, sendEmail: true });
      setSubmitted(true);
    }
    return (
      <>
        <HorizontalLayout style={{ justifyContent: "center"}}>
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              onClick={() => {setRating(star); saveRating({ rating: star, feedback, sendEmail: false });}}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "2rem",
                color:
                  star <= (hover || rating)
                    ? "var(--warning-500)"
                    : "var(--grey-300)",
              }}
              aria-label={`Rate ${star} stars`}
            >
              ★
            </button>
          ))}
        </HorizontalLayout>
        {rating > 0 && (
          <>
          <TextAreaForm value={feedback} typeInput={(v) => setFeedback(v)} placeholder="Toelichting" />
            <HorizontalLayout>
              <StandardButton
                onClick={handleSubmit}
                disabled={submitted}
                style={{
                  marginLeft: "auto",
                  background: submitted
                    ? "var(--success-500)"
                    : "var(--primary-500)",
                }}
              >
                {submitted ? "Bedankt voor je feedback!" : "Versturen"}
              </StandardButton>
            </HorizontalLayout>
          </>
        )}
      </>
    );
  };


  const NoEmail = ({completionEmail, setCompletionEmail, emailError, handleEmailSubmit, emailSubmitting, emailSubmitted, triggerConfetti}) => {

    return (
      <VerticalLayout
          className="center-all phone-result-container"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            maxWidth: "400px",
            padding: "2rem",
          }}
        >
          <div style={{ color: "green", marginBottom: "0.5rem" }}>{icon("checkbox-check", 96)}</div>
          <h6 style={{ color: "var(--grey-900)", marginBottom: "1rem" }}>
            Je hebt de e-learning afgerond.
          </h6>
          <div style={{ width: "100%", height: "auto", marginBottom: "1rem" }}>
            <p style={{ margin: "0 0 1rem 0", textAlign: "left", color: "var(--grey-600)", fontSize: "0.9rem" }}>
              Wil je geen interessante inzichten missen? Laat hieronder je e-mailadres achter.
            </p>
            <div style={{ marginBottom: "1rem", textAlign: "left" }}>
              <input
                type="email"
                value={completionEmail}
                onChange={(e) => setCompletionEmail(e.target.value)}
                placeholder="voorbeeld@example.com"
                style={{
                  width: "100%",
                  padding: "0.75rem",
                  borderRadius: "0.5rem",
                  border: "1px solid var(--grey-300)",
                  fontSize: "1rem",
                  boxSizing: "border-box",
                }}
              />
              {emailError !== "" && <label style={{ color: "red", fontSize: "0.75rem" }}>{emailError}</label>}
            </div>
            <HorizontalLayout className="phone-result">
              <StandardButton
                onClick={handleEmailSubmit}
                disabled={emailSubmitting || emailSubmitted}
                style={{
                  background: emailSubmitted ? "var(--success-500)" : "var(--primary-500)",
                  padding: "0.75rem",
                  marginLeft: "0rem",
                }}
              >
                {emailSubmitting ? (
                  <Spinner color="white" size="1rem" />
                ) : emailSubmitted ? (
                  "We houden je op de hoogte!"
                ) : (
                  "Op de hoogte blijven"
                )}
              </StandardButton>
              <StandardButton
                onClick={triggerConfetti}
                style={{
                  background: "var(--success-500)",
                  padding: "0.75rem 1.5rem",
                }}
              >
                🎉
              </StandardButton>
            </HorizontalLayout>
          </div>
        </VerticalLayout>
    )
  }
  var confettiEnabled = false;
  export  function AssessmentFinishedTap({elearningInformation, id, code, goBack}) {
    
    const [emailSubmitting, setEmailSubmitting] = useState(false);
    const [emailSubmitted, setEmailSubmitted] = useState(false);  
    const [emailError, setEmailError] = useState("");
    const jsConfettiRef = useRef(null);
      const triggerConfetti = () => {
      const jsConfetti = jsConfettiRef.current || new JSConfetti();
      jsConfettiRef.current = jsConfetti;
      if (!confettiEnabled) {
        confettiEnabled = true;
        const interval = setInterval(() => jsConfetti.addConfetti(), 150);
        setTimeout(() => { clearInterval(interval); confettiEnabled = false; }, 1000);
      }
    };
    const handleEmailSubmit = async () => {      
        setEmailSubmitting(true);
        try {
          const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
          const authToken = parsed?.token;
          const response = await fetch(`${ip}/api/cards/results`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Auth-Token": authToken },
            body: JSON.stringify({ card_code: code, id_course: id })
          });
          if (response.ok) setEmailSubmitted(true);
          else setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw.");
        } catch { setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw."); }
        finally { setEmailSubmitting(false); }
    };


    const backToFeed = async () => {
      await  handleEmailSubmit()
      setTimeout(() => {
          goBack()
      }, 1000);

    }
    return (
      <div style={{ background: "var(--grey-50)", height: "100vh" }}>
        <div
          style={{ backgroundImage: `url('${elearningInformation.image_url}')` }}
          className="topbar-embed-bg"
        >
          <div className="topbar-embed">{elearningInformation.title}</div>
        </div>
        <VerticalLayout
          className="center-all phone-result-container"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            maxWidth: "400px",
            padding: "2rem",
          }}
        >
          <div style={{ color: "green", marginBottom: "0.5rem" }}>{icon("checkbox-check", 96)}</div>
          <h6 style={{ color: "var(--grey-900)", marginBottom: "1rem" }}>
            Je hebt de e-learning afgerond.
          </h6>
          <div style={{ width: "100%", height: "auto", marginBottom: "1rem" }}>
            <p style={{ margin: "0 0 1rem 0", textAlign: "left", color: "var(--grey-600)", fontSize: "0.9rem" }}>
              De resultaten zijn opgeslagen. Verstuur hieronder direct naar je mailadres en ga terug naar je feed.
            </p>

            <HorizontalLayout className="phone-result">
              <StandardButton
                onClick={backToFeed}
                disabled={emailSubmitting || emailSubmitted}
                style={{
                  background: emailSubmitted ? "var(--success-500)" : "var(--primary-500)",
                  padding: "0.75rem",
                  marginLeft: "0rem",
                }}
              >
                {emailSubmitting ? (
                  <Spinner color="white" size="1rem" />
                ) : emailSubmitted ? (
                  "Resultaten verzonden!"
                ) : (
                  "Resultaten ontvangen"
                )}
              </StandardButton>
              <StandardButton
                onClick={triggerConfetti}
                style={{
                  background: "var(--success-500)",
                  padding: "0.75rem 1.5rem",
                }}
              >
                🎉
              </StandardButton>
            </HorizontalLayout>
          </div>
        </VerticalLayout>
      </div>
    );
  };